<template>
  <!-- Hero Section -->
  <section class="bg-gradient-to-r from-gray-50 to-gray-100 py-16" id="home">
    <div class="container mx-auto px-4 flex flex-col md:flex-row items-center">
      <div class="md:w-1/2 text-left space-y-6">
        <h1 class="text-4xl md:text-5xl font-bold mb-2">
          <span class="text-[#B89666]">Lexo</span>
          <br>Poveži se s pravnimi in upravnimi strokovnjaki
        </h1>
        <p class="mb-3 text-lg text-gray-600">
          Lexo povezuje posameznike in podjetja z lokalnimi  strokovnjaki za pravne in upravne zadeve.
        </p>
        <div class="bg-white border rounded-lg p-4 mb-3 shadow">
          <div class="flex flex-col md:flex-row gap-2">
            <div class="flex items-center border rounded px-2 w-full">
              <span class="text-gray-400 mr-2"><i class="ti ti-search"></i></span>
              <select class="flex-1 py-2 outline-none" v-model="selectedCompanyType" @change="scrollToQuestionForm">
                <option disabled selected value="">Izberite tip strokovnjaka</option>
                <option value="law_office">Odvetniki</option>
                <option value="notary">Notarji</option>
                <option value="appraiser">Cenilci</option>
                <option value="liquidator">Stečajni upravitelji</option>
                <option value="court_expert">Sodni izvedenec</option>
                <option value="court_interpreter">Sodni tolmač</option>
                <option value="enforcement_officer">Izvršitelj</option>
                <option value="settlement_mediator">Poravnalec</option>
              </select>
            </div>
            <div>
              <button 
                class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" 
                type="button"
                @click="scrollToQuestionForm"
                :disabled="!selectedCompanyType"
              >
                <i class="ti ti-arrow-right mr-2"></i>Pošljite vprašanje
              </button>
            </div>
          </div>
        </div>
        <div class="flex flex-wrap gap-8 mt-6">
          <div class="flex items-center gap-2">
            <img src="/images/icons/map-marker-account-outline.svg" alt="Lokalni strokovnjaki" title="Lokalni strokovnjaki" class="h-8 w-8" />
            <div>
              <h6 class="font-bold">Lokalni strokovnjaki</h6>
              <p class="text-xs text-gray-500">Samo 1 klik stran</p>
            </div>
          </div>
          <div class="flex items-center gap-2">
            <img src="/images/icons/human-greeting-proximity.svg" alt="Neposreden stik" title="Neposreden stik" class="h-8 w-8" />
            <div>
              <h6 class="font-bold">Neposreden stik</h6>
              <p class="text-xs text-gray-500">Storitve na dlani</p>
            </div>
          </div>
          <div class="flex items-center gap-2">
            <img src="/images/icons/lock-check-outline.svg" alt="Varna komunikacija" title="Varna komunikacija" class="h-8 w-8" />
            <div>
              <h6 class="font-bold">Varna komunikacija</h6>
              <p class="text-xs text-gray-500">Brez skrbi</p>
            </div>
          </div>
        </div>
      </div>
      <div class="md:w-1/2 flex justify-center mt-8 md:mt-0">
        <img src="/images/web/lexo-home.png" alt="Banner" title="Banner" class="max-w-md w-full animation-float" />
      </div>
    </div>
  </section>
  <!-- /Hero Section -->
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useMainStore } from '@/stores/main'

const mainStore = useMainStore()
const selectedCompanyType = ref('')

const scrollToQuestionForm = () => {
  if (selectedCompanyType.value) {
    scrollToQuestionWithType(selectedCompanyType.value)
  }
}

const scrollToQuestionWithType = (companyType) => {
  // Store the company type in the store
  mainStore.setSelectedQuestionCompanyType(companyType)
  
  const element = document.getElementById('send-question')
  if (element) {
    // Update URL hash only (no query parameters)
    const url = new URL(window.location.href)
    url.hash = 'send-question'
    window.history.pushState({}, '', url.toString())
    
    // Scroll to element
    setTimeout(() => {
      element.scrollIntoView({ behavior: 'smooth' })
    }, 100)
  }
}

// Handle clicks on anchor links
onMounted(() => {
  // Listen for hash changes
  const handleHashChange = () => {
    const hash = window.location.hash
    if (hash.includes('send-question')) {
      const element = document.getElementById('send-question')
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' })
        }, 100)
      }
    }
  }
  
  window.addEventListener('hashchange', handleHashChange)
  
  // Check on mount if we're already on the hash
  if (window.location.hash.includes('send-question')) {
    handleHashChange()
  }
})
</script> 